<template>
  <section>
    <div class="card-band-styling">
      <h3>Forgot Password</h3>
      <div>
        <div>Registered Email</div>
        <div>
          <input type="email" v-model="inputObjectForgotPass.email" />
        </div>
        <div id="errorPassword-forgotPass" class="warning-alert">
        </div>
      </div>
      <div id="confirmEmailSent-forgotPass" class="confirmation-alert">
      </div>
      <div class="button-container">
        <button @click="submitForgotPassword">
          <b-spinner small v-if="loadingForgotPassword"></b-spinner>
          <span v-if="loadingForgotPassword">Sending email</span>
          <span v-else>Send Email</span>
        </button>
      </div>
    </div>

    <div class="card-band-styling">
      <h3>Reset Password</h3>
      <div>
        <div>
          <div>Email Address</div>
          <div>
            <input type="text" v-model="inputObjectResetPass.email" />
          </div>
          <div id="errorEmail-resetPass" class="warning-alert">
          </div>
        </div>
        <div>
          <div>Verify Token</div>
          <div>
            <input type="text" v-model="inputObjectResetPass.verifyToken" />
          </div>
          <div id="errorToken-resetPass" class="warning-alert">
          </div>
        </div>
        <div>
          <div>New Password</div>
          <div>
            <input v-if="passwordShow2 == false" type="password" v-model="inputObjectResetPass.newPass" />
            <input v-if="passwordShow2" type="text" v-model="inputObjectResetPass.newPass" />
            <b-icon-eye-fill v-if="passwordShow2 == false" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('2')"></b-icon-eye-fill>
            <b-icon-eye-slash-fill v-if="passwordShow2" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('2')"></b-icon-eye-slash-fill>
          </div>
          <div id="errorNewPassword-resetPass" class="warning-alert">
          </div>
        </div>
        <div>
          <div>Confirm New Password</div>
          <div>
            <input v-if="passwordShow3 == false" type="password" v-model="inputObjectResetPass.confNewPass" />
            <input v-if="passwordShow3" type="text" v-model="inputObjectResetPass.confNewPass" />
            <b-icon-eye-fill v-if="passwordShow3 == false" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('3')"></b-icon-eye-fill>
            <b-icon-eye-slash-fill v-if="passwordShow3" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('3')"></b-icon-eye-slash-fill>
          </div>
          <div id="errorConfNewPassword-resetPass" class="warning-alert">
          </div>
        </div>
        <div id="confirmPassReset-forgotPass" class="confirmation-alert">
        </div>
      </div>
      <div class="button-container">
        <button @click="submitResetPassword">
          <b-spinner small v-if="loadingResetPassword"></b-spinner>
          <span v-if="loadingResetPassword">Updating password</span>
          <span v-else>Submit</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  import instance from "../axios.js";
  import { BIconEyeFill, BIconEyeSlashFill } from "bootstrap-vue";

  export default {
    components: {
      BIconEyeFill,
      BIconEyeSlashFill,
    },
    data() {
      return {
        inputObjectForgotPass: {
          email: ''
        },
        inputObjectResetPass: {
          email: '',
          verifyToken: '',
          newPass: '',
          confNewPass: ''
        },
        passwordShow2: false,
        passwordShow3: false,
        errors: {},
        loadingForgotPassword: false,
        loadingResetPassword: false,
      }
    },
    methods: {
      togglePassword(number) {
        if (number == "1") {
          this.passwordShow1 = !this.passwordShow1;
        }
        if (number == "2") {
          this.passwordShow2 = !this.passwordShow2;
        }
        if (number == "3") {
          this.passwordShow3 = !this.passwordShow3;
        }
      },
      sendResetEmail() {
        document.getElementById('confirmEmailSent-forgotPass').innerText = '';
        var registeredEmail = this.inputObjectResetPass.email;

        let dataToSubmit = {
          email: registeredEmail,
          password: "",
        };

        instance.post("api/auth/forgot-pass", dataToSubmit)
          .then(response => {
            console.log(response);
            this.loadingForgotPassword = false;
            document.getElementById('confirmEmailSent-forgotPass').innerText = 'A reset token has been emailed to your account. Enter it along with your new passwords in the new section.';
          })
          .catch((error) => console.log(error));

      },
      submitForgotPassword() {
        this.errors = {};
        document.getElementById('errorPassword-forgotPass').innerText = '';

        let forgotPassword = this.inputObjectForgotPass.email;
        const validForgotPassword = this.validateForgotPassword(forgotPassword);
        if (!validForgotPassword.valid) {
          document.getElementById('errorPassword-forgotPass').innerText = validForgotPassword.error;
        } else {
          this.loadingForgotPassword = true;
          this.sendResetEmail();
        }
      },
      submitResetPassword() {
        this.errors = {};
        let verifyToken = this.inputObjectResetPass.verifyToken;
        let registeredEmail = this.inputObjectResetPass.email;
        let resetPassword = this.inputObjectResetPass.newPass;
        let confirmResetPassword = this.inputObjectResetPass.confNewPass;

        let valid = true;

        document.getElementById('errorEmail-resetPass').innerText  = '';
        document.getElementById('errorToken-resetPass').innerText  = '';
        document.getElementById('errorNewPassword-resetPass').innerText = '';
        document.getElementById('errorConfNewPassword-resetPass').innerText = '';
        document.getElementById('confirmPassReset-forgotPass').innerText = '';

        const validEmail = this.validateEmail(registeredEmail);
        if (!validEmail.valid) {
          valid = false;
          document.getElementById('errorEmail-resetPass').innerText  = validEmail.error;
        }

        if (!verifyToken || verifyToken.length == 0) {
          valid = false;
          document.getElementById('errorToken-resetPass').innerText = "This field is required";
        }

        const validResetPassword = this.validateResetPassword(resetPassword);
        if (!validResetPassword.valid) {
          valid = false;
          document.getElementById('errorNewPassword-resetPass').innerText = validResetPassword.error;
        }

        const validConfirmResetPassword = this.validateConfirmResetPassword(confirmResetPassword, resetPassword);
        if (!validConfirmResetPassword.valid) {
          valid = false;
          document.getElementById('errorConfNewPassword-resetPass').innerText = validConfirmResetPassword.error;
        }

        if (valid) {
          this.loadingResetPassword = true;

          let dataToSubmit = {
            token: verifyToken,
          };

          instance
            .post("api/auth/verify-token", dataToSubmit)
            .then((response) => {
              var message = response.data.message;
              if (message == "successfully verified") {
                let dataToSubmit2 = {
                  id: response.data.userId,
                  email: registeredEmail,
                  password: resetPassword,
                  pending: "",
                  token: "",
                };

                instance
                  .post("api/auth/reset-pass", dataToSubmit2)
                  .then((response) => {
                    console.log(response.data.message);
                    this.loadingResetPassword = false;
                    document.getElementById('confirmPassReset-forgotPass').innerText = 'Your password has been successfully reset! Use the new password to login.';
                  })
                  .catch((error) => {
                    this.loadingResetPassword = false;
                    console.log(error);
                  });
              }
            })
            .catch((error) => console.log(error));
        }
      },
      validateResetPassword(resetPassword) {
        if (!resetPassword.length || resetPassword == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (resetPassword.length < 8) {
          return {
            valid: false,
            error: "Password requires at least 8 characters",
          };
        }
        if (
          !/[~`!#$@%&*+=\-';,/{}|":<>]/g.test(resetPassword) ||
          !/\d/.test(resetPassword)
        ) {
          return {
            valid: false,
            error:
              "Password requires at least 1 number and 1 special character (e.g. '$', '%', '@').",
          };
        }
        return { valid: true, error: null };
      },
      validateForgotPassword(forgotPassword) {
        if (!forgotPassword.length || forgotPassword.length == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (
          forgotPassword.match(/^\w+([.-]?\w+)_@\w+(_[_.-]?\w+)_(.\w{2,3})+$/)
        ) {
          return {
            valid: false,
            error: "Please enter a valid email.",
          };
        }
        return { valid: true, error: null };
      },
      validateConfirmResetPassword(confirmResetPassword, password) {
        if (!confirmResetPassword.length || confirmResetPassword == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (confirmResetPassword != password) {
          return {
            valid: false,
            error: "The passwords you entered did not match",
          };
        }

        return { valid: true, error: null };
      },
      validateEmail(email) {
        if (!email.length || email.length == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (email.match(/^\w+([.-]?\w+)_@\w+(_[_.-]?\w+)_(.\w{2,3})+$/)) {
          return {
            valid: false,
            error: "Please enter a valid email.",
          };
        }
        return { valid: true, error: null };
      },
    }
  };
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  input {
    width: 100%;
  }

  .card-band-styling {
    width: 75%;
  }

  .warning-alert {
    background-color: #ED7878;
    border-radius: 5px;
    margin: 5px 0;
  }

  .confirmation-alert {
    background-color: #6BFF6B;
    border-radius: 5px;
    margin: 5px 0;
  }

  h3 {
    text-align: center;
  }

  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>